<template>
  <div class="ms-4 py-1 m-2 condition-border">
    <select
      v-model="select"
      class="form-select"
      aria-label="Default select example"
      @change="changePropertyValue('complied')"
    >
      <option :value="true">
        {{ trans('subscription.classification_config.selectors.subscribable_grouping.should_comply') }}
      </option>
      <option :value="false">
        {{ trans('subscription.classification_config.selectors.subscribable_grouping.should_not_comply') }}
      </option>
    </select>
  </div>
</template>

<script>
import selectorMixin from '@/employees/components/Selector/utilities/mixins/selectorMixin'
export default {
  name: 'SelectorSubscribableGrouping',
  mixins: [selectorMixin],
  props: {
    selectorReference: {
      required: true,
      type: String,
    },
    selector: {
      required: true,
      type: Object,
    },
  },
  data () {
    return {
      select: true,
    }
  },
  mounted () {
    this.select = this.selector.complied
  },
  methods: {
    changePropertyValue (selectorPropertyEnum) {
      this.selectorPropertyValueChange(this.selectorReference, selectorPropertyEnum, this.select)
    },
  },
}
</script>

<style scoped>
/deep/
.form-control {
  width: auto;
}
</style>
